import { TweenMax, easeOut } from 'gsap/all';

function SelectBox(item) {
    var optionsBox = item.querySelector('.select-wrapper'),
        options = item.querySelectorAll('.select-option'),
        label = item.querySelector('.trigger-select');

    var selectTL = new TimelineMax({ paused: true, reversed: true })
        .set(item, { className: '+=opened' })
        .to(item, 0.3, { height: 140, borderRadius: 30 })
        .to(label, 0.2, { opacity: 0 },'-=0.2')
        .to(optionsBox, 0.3, { transformOrigin: 'center top', scaleY: 1 }, '-=0.2')
        .to(options, 0.3, { opacity: 1 }, '-=0.3');

    selectTL.play();
    var trackQuality = document.getElementById('track-quality');

    for(var option of Array.from(options)) {
        option.addEventListener('click', (e) => {
            console.log();
            var _this = e.target || window.event;
            var value = _this.getAttribute('data-value');
            label.textContent = value;
            trackQuality.value = value;

            selectTL.reverse();

        })
    }

}

export default SelectBox;



// WEBPACK FOOTER //
// ./resources/js/components/SelectBox.js